module.exports = __webpack_public_path__ + "static/AgentMarketing-84a20f23aec73029d97654744381f816.jpg";